import React, { ReactElement } from "react";
import { Role } from "../../redux/api-model/organization/company";
import { useGeneralState } from "../../redux/general/selectors";

type Props = {
  visibleFor: Role[];
  children: React.ReactNode;
};

export function getIsVisibleFor(currentRole: Role, roles?: Role[]): boolean {
  return Boolean(roles?.includes(currentRole));
}

export function useVisibleOnlyFor(
  roles: Array<Role>
): <T>(action: T) => T | undefined {
  const currentRole = useGeneralState().userSelection.type;

  return function <T>(action: T): T | undefined {
    if (getIsVisibleFor(currentRole, roles)) {
      return action;
    }
    return undefined;
  };
}

export const makeComponentForRole =
  (Component: (...args: Array<any>) => ReactElement, role: Role) =>
  <T,>(props: T): ReactElement | null => {
    const currentRole = useGeneralState().userSelection.type;

    if (currentRole === role) {
      return <Component {...props} />;
    }

    return null;
  };

const Authorized = (props: Props): React.ReactElement => {
  const currentRole = useGeneralState().userSelection.type;
  if (
    props.visibleFor?.includes(currentRole) ||
    props.visibleFor?.includes(Role.ALL)
  ) {
    return <>{props.children}</>;
  } else {
    return <></>;
  }
};

export function RenderForRole(props: {
  roles: { [key in Role]?: ReactElement | string };
}): ReactElement | string {
  const currentRole = useGeneralState().userSelection.type;
  return props.roles[currentRole] ?? <></>;
}

export default Authorized;
